var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            title: "CAPI Event Gönder",
            okText: "Gönder",
            cancelText: "İptal",
          },
          on: { cancel: _vm.handleCancel, ok: _vm.handleSend },
        },
        [
          _c("div", { staticClass: "send-capi-event-form" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v("Kanal "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "Bir kanal seçin",
                      readonly: "",
                      disabled: "",
                    },
                    on: { change: _vm.handleChannelChange },
                    model: {
                      value: _vm.form.channelId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelId", $$v)
                      },
                      expression: "form.channelId",
                    },
                  },
                  _vm._l(_vm.availableChannels, function (channel) {
                    return _c(
                      "a-select-option",
                      { key: channel._id, attrs: { value: channel._id } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(channel.name) +
                            " (" +
                            _vm._s(channel.type) +
                            ")\n                "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v("Event Tipi "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { placeholder: "Event tipi seçin" },
                    model: {
                      value: _vm.form.eventType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "eventType", $$v)
                      },
                      expression: "form.eventType",
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { attrs: { value: "LeadSubmitted" } },
                      [_vm._v("Lead Gönderildi")]
                    ),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "Purchase" } }, [
                      _vm._v("Satın Alma"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "InitiateCheckout" } },
                      [_vm._v("Sohbet Başlatıldı")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "AppointmentBooked" } },
                      [_vm._v("Randevu Oluşturuldu")]
                    ),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "AddToCart" } }, [
                      _vm._v("Sepete Eklendi"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "ViewContent" } }, [
                      _vm._v("İçerik Görüntülendi"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "OrderCreated" } },
                      [_vm._v("Sipariş Oluşturuldu")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "OrderShipped" } },
                      [_vm._v("Sipariş Kargoya Verildi")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            ["Purchase", "OrderCreated", "OrderShipped"].includes(
              _vm.form.eventType
            )
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Para Birimi")]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "Para birimi" },
                        model: {
                          value: _vm.form.currency,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "currency", $$v)
                          },
                          expression: "form.currency",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "TRY" } }, [
                          _vm._v("TRY - Türk Lirası"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "USD" } }, [
                          _vm._v("USD - Amerikan Doları"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "EUR" } }, [
                          _vm._v("EUR - Euro"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "GBP" } }, [
                          _vm._v("GBP - İngiliz Sterlini"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            ["Purchase", "OrderCreated", "OrderShipped"].includes(
              _vm.form.eventType
            )
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Tutar")]),
                    _vm._v(" "),
                    _c("a-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "0.00", min: 0, step: 0.01 },
                      model: {
                        value: _vm.form.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "value", $$v)
                        },
                        expression: "form.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Ek Bilgiler (Opsiyonel)")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-data-list" },
                [
                  _vm._l(_vm.form.customDataList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "custom-data-item" },
                      [
                        _c("a-input", {
                          staticStyle: { width: "40%" },
                          attrs: { placeholder: "Anahtar" },
                          model: {
                            value: item.key,
                            callback: function ($$v) {
                              _vm.$set(item, "key", $$v)
                            },
                            expression: "item.key",
                          },
                        }),
                        _vm._v(" "),
                        _c("a-input", {
                          staticStyle: { width: "50%" },
                          attrs: { placeholder: "Değer" },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                        _vm._v(" "),
                        _c("SupsisButton", {
                          attrs: { danger: "", icon: "delete" },
                          on: {
                            click: function ($event) {
                              return _vm.removeCustomData(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { icon: "add" },
                      on: { click: _vm.addCustomData },
                    },
                    [
                      _vm._v(
                        "\n                    Ek Alan Ekle\n                "
                      ),
                    ]
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.contact
              ? _c("div", { staticClass: "info-section" }, [
                  _c("h4", [_vm._v("Kişi Bilgileri")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [_vm._v("Ad:")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.contact.fullname || "N/A")),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("Platform:"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.contact.platform)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.contact.meta_ids
                      ? _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Meta ID:"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.getMetaIdDisplay())),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }